import { render, staticRenderFns } from "./estado-tags.vue?vue&type=template&id=1a36aacd&scoped=true&"
import script from "./estado-tags.component.ts?vue&type=script&lang=ts&"
export * from "./estado-tags.component.ts?vue&type=script&lang=ts&"
import style0 from "./estado-tags.vue?vue&type=style&index=0&id=1a36aacd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36aacd",
  null
  
)

export default component.exports